import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import GoalIndividualPage from './GoalIndividualPage';

const GoalIndividualPageWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { goalId } = params;

  // console.log('GoalIndividualPageWrapper - All params:', params);
  // console.log('GoalIndividualPageWrapper - goalId from params:', goalId);
  // console.log('GoalIndividualPageWrapper - location state:', location.state);
  // console.log('GoalIndividualPageWrapper - location pathname:', location.pathname);
  // console.log('GoalIndividualPageWrapper - location search:', location.search);

  return (
    <GoalIndividualPage 
      navigate={navigate}
      location={location}
      goalId={goalId}
    />
  );
};

export default GoalIndividualPageWrapper;
